/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function CarListDtoFromJSON(json) {
    return CarListDtoFromJSONTyped(json, false);
}
export function CarListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'carModelName': !exists(json, 'carModelName') ? undefined : json['carModelName'],
        'carMakeName': !exists(json, 'carMakeName') ? undefined : json['carMakeName'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'carMakeId': !exists(json, 'carMakeId') ? undefined : json['carMakeId'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'acceleration': !exists(json, 'acceleration') ? undefined : json['acceleration'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'maxSpeed': !exists(json, 'maxSpeed') ? undefined : json['maxSpeed'],
        'engineCapacity': !exists(json, 'engineCapacity') ? undefined : json['engineCapacity'],
        'mainPhoto': !exists(json, 'mainPhoto') ? undefined : OrderedFileDtoFromJSON(json['mainPhoto']),
    };
}
export function CarListDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'carModelId': value.carModelId,
        'carModelName': value.carModelName,
        'carMakeName': value.carMakeName,
        'plateNumber': value.plateNumber,
        'carMakeId': value.carMakeId,
        'manufactureYear': value.manufactureYear,
        'acceleration': value.acceleration,
        'enginePower': value.enginePower,
        'maxSpeed': value.maxSpeed,
        'engineCapacity': value.engineCapacity,
        'mainPhoto': OrderedFileDtoToJSON(value.mainPhoto),
    };
}
